import { useState } from "react";
import { Box } from "@mui/material";
import MyContainer from "@/components/MyContainer";
import FulfillmentForm from "@/pages/fulfillment/form/fulfillment-form";
import { SaveButton } from "@/components/ui/buttons/save-button";

export function CreateFulfillmentPage() {
  const [formHandlers, setFormHandlers] = useState<{
    handleSubmit: () => void;
    isSubmitting: boolean;
  } | null>(null);

  return (
    <MyContainer
      title="Create Fulfillment"
      subtitle="Create a new fulfillment"
      actions={
        formHandlers ? (
          <SaveButton
            disabled={formHandlers.isSubmitting}
            handleSave={formHandlers.handleSubmit}
          />
        ) : undefined
      }
      footer={
        formHandlers ? (
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <SaveButton
              disabled={formHandlers.isSubmitting}
              handleSave={formHandlers.handleSubmit}
            />
          </Box>
        ) : undefined
      }
    >
      <FulfillmentForm
        mode="create"
        onFormReady={(handlers) => setFormHandlers(handlers)}
      />
    </MyContainer>
  );
}
